import { useEffect } from 'react';

import useGuidedTour from 'src/components/app/context/GuidedTourContext';
import { useDashboardContext } from 'src/components/dashboard/DashboardContext';

export const useGuidedTourOnDashboard = (guidedTourOrgTreeId: string) => {
  const { dashboardConfig } = useDashboardContext();
  const { addSteps } = useGuidedTour();

  useEffect(() => {
    const {
      show_guided_tour: show,
      guided_tour_start_step: startStep,
      guided_tour_org_tree_step: orgTreeStep,
      guided_tour_second_org_tree_step: secondOrgTreeStep,
      guided_tour_end_step: endStep,
    } = dashboardConfig ?? {};

    if (!show) {
      return;
    }

    addSteps([
      startStep && {
        id: 'dashboard-start-step',
        ...startStep,
        placement: 'left-start',
        appendToStart: true,
      },
      orgTreeStep && {
        id: 'dashboard-org-tree-step-1',
        ...orgTreeStep,
        target: `#${guidedTourOrgTreeId}`,
        appendToEnd: true,
      },
      secondOrgTreeStep && {
        id: 'dashboard-org-tree-step-2',
        ...secondOrgTreeStep,
        target: `#${guidedTourOrgTreeId}`,
        appendToEnd: true,
      },
      endStep && {
        id: 'dashboard-end-step',
        ...endStep,
        appendToEnd: true,
        followUpLinks: true,
      },
    ]);
  }, [dashboardConfig]);
};
